import { IResult, ITrackLineParameter } from "@/types/map";
import { loadModules } from "esri-loader";

export default class TrackLine {
  private view!: __esri.MapView;
  private static intances: Map<string, TrackLine>;

  private trackLayer!: __esri.GraphicsLayer;
  private iswgs = true;
  private MintrackLen: number = 0.001; //每次移动的距离
  private MoveStart: boolean = true;
  private moveId: string = "";

  private constructor(view: __esri.MapView) {
    this.view = view;
  }
  public static getInstance(view: __esri.MapView) {
    const id = view.container.id;
    if (!TrackLine.intances) {
      TrackLine.intances = new Map();
    }
    let instance = TrackLine.intances.get(id);
    if (!instance) {
      instance = new TrackLine(view);
      TrackLine.intances.set(id, instance);
    }
    return instance;
  }
  public stopTrackLine() {
    this.doLayerDefinition("情报板", "DEVICETYPE='1'");
    this.MoveStart = false;
    if (this.trackLayer) {
      this.trackLayer.removeAll();
    }
  }
  public async startTrackLine(params: ITrackLineParameter): Promise<IResult> {
    this.stopTrackLine();
    this.MoveStart = true;
    type MapModules = [
      typeof import("esri/layers/GraphicsLayer"),
      typeof import("esri/Graphic"),
      typeof import("esri/geometry/Multipoint")
    ];
    const [GraphicsLayer, Graphic, Multipoint] = await (loadModules([
      "esri/layers/GraphicsLayer",
      "esri/Graphic",
      "esri/geometry/Multipoint",
    ]) as Promise<MapModules>);

    if (!this.trackLayer) {
      this.trackLayer = new GraphicsLayer();
      this.view.map.add(this.trackLayer, 1);
    } else {
      this.trackLayer.removeAll();
    }

    let eventWhere = "FSTR_ID='" + params.eventId + "'";
    let qbbids = params.QBBIds || [];
    this.moveId = (Math.random() * 100000).toFixed(0);

    let qbbExpress = this.getArrayStr(qbbids);
    qbbExpress = "DEVICEID in (" + qbbExpress + ")";
    let event = await this.queryTask("交通事件", eventWhere);
    let qbbs = await this.queryTask("情报板", qbbExpress);
    let allGraphics = [].concat(event).concat(qbbs);

    var allPoints = new Multipoint({
      spatialReference: { wkid: 4326 },
    });
    allGraphics.forEach((graphic: any) => {
      allPoints.addPoint(graphic.geometry);
    });
    let ext = allPoints.extent.expand(4);
    let subx = ext.xmax - ext.xmin;
    let suby = ext.ymax - ext.ymin;

    //中心往下偏移0.02
    ext.ymin = ext.ymin + Math.max(Math.max(subx, suby), 0.08) / 5;
    await this.view.goTo({ target: ext });
    let _this = this;
    let qbbShowIds: string[] = [];

    if (event.length > 0) {
      let startPoint = [event[0].geometry.x, event[0].geometry.y];
      qbbs.forEach((qbb: any, index: number) => {
        let endPoint = [qbb.geometry.x, qbb.geometry.y];
        _this.startMove(
          [startPoint, endPoint],
          _this.moveId,
          (callbackid: string) => {
            //跑完回调
            //layer.visible = true;
            if (_this.moveId === callbackid) {
              qbbShowIds.push(qbb.attributes.DEVICEID);
              _this.doLayerDefinition(
                "情报板",
                "DEVICEID in (" + _this.getArrayStr(qbbShowIds) + ")"
              );
            }
          }
        );
      });
    }

    return { message: "", status: 0, result: "" };
  }
  //字符串数组转字符串
  private getArrayStr(arr: string[]): string {
    let express = "";
    for (let i = 0; i < arr.length; i++) {
      express += "'" + arr[i] + "',";
    }
    express = express.substr(0, express.length - 1);
    return express;
  }
  private doLayerDefinition(layerName: string, express: string) {
    let queryLayer: any;
    this.view.map.allLayers.toArray().forEach((layer: any) => {
      if (layer.label == layerName) {
        queryLayer = layer;
      }
    });
    if (queryLayer) {
      queryLayer.definitionExpression = express;
    }
    return queryLayer;
  }
  public async queryTask(layerName: string, express: string) {
    let queryLayer: any;
    this.view.map.allLayers.toArray().forEach((layer: any) => {
      if (layer.label == layerName) {
        queryLayer = layer;
      }
    });
    if (queryLayer) {
      const query = queryLayer.createQuery();
      query.where = express;
      query.outFields = ["*"];
      query.outSpatialReference = { wkid: 4326 };
      const results = await queryLayer.queryFeatures(query);
      if (results.features && results.features.length > 0) {
        return results.features;
      }
    }
    return [];
  }
  private async startMove(
    points: Array<Array<number>>,
    moveid: string,
    callback: any
  ) {
    let polyline = await this.compactLine(points);
    let compactPaths = polyline.paths[0];
    let line = {
      paths: compactPaths,
      moveid: moveid,
      moveIndex: 0,
      movePaths: [],
      graphic: undefined,
      callback,
    };
    this.moveLine(line);
  }
  //致密线
  private async compactLine(points: Array<Array<number>>) {
    const [
      geometryJsonUtils,
      geodesicUtils,
      geometryEngine,
      Graphic,
    ] = await loadModules([
      "esri/geometry/support/jsonUtils",
      "esri/geometry/support/geodesicUtils",
      "esri/geometry/geometryEngine",
      "esri/Graphic",
    ]);
    let geometry = this.iswgs
      ? geometryJsonUtils.fromJSON({
          paths: [points],
        })
      : geometryJsonUtils.fromJSON({
          paths: [points],
          spatialReference: this.view.spatialReference,
        });
    let compactPoint = this.iswgs
      ? geometryEngine.geodesicDensify(geometry, 50)
      : geometryEngine.densify(geometry, 50, "meters");
    return compactPoint;
  }
  public async moveLine(obj: {
    paths: Array<Array<number>>;
    moveIndex: number;
    moveid: string;
    movePaths: Array<Array<number>>;
    graphic?: __esri.Graphic;
    callback?: any;
  }) {
    const [geometryJsonUtils, geometryEngine, Graphic] = await loadModules([
      "esri/geometry/support/jsonUtils",
      "esri/geometry/geometryEngine",
      "esri/Graphic",
    ]);
    let _this = this;
    let index = obj.moveIndex;
    if (index < obj.paths.length - 1) {
      let endPoint = obj.paths[index + 1];
      if (obj.moveIndex == 0) {
        obj.movePaths.push(obj.paths[0]);
        obj.graphic = new Graphic({
          symbol: {
            type: "simple-line",
            color: [0, 255, 255, 255],
            style: "short-dash",
            width: 2,
          },
        });
        this.trackLayer.add(obj.graphic as __esri.Graphic);
      }
      obj.movePaths.push(endPoint);
      let geometry = this.iswgs
        ? geometryJsonUtils.fromJSON({
            paths: obj.movePaths,
          })
        : geometryJsonUtils.fromJSON({
            paths: obj.movePaths,
            spatialReference: this.view.spatialReference,
          });
      if (obj.graphic) {
        obj.graphic.geometry = geometry;
      }
      if (_this.MoveStart) {
        obj.moveIndex++;
        setTimeout(() => {
          _this.moveLine(obj);
        }, 10);
      }
    } else {
      if (obj.callback) {
        obj.callback(obj.moveid);
      }
    }
  }
}
